import { usePusherConnected } from '@/composables/push/pusher'

export function useOnlineStatus(onRefresh: () => void) {
  const isOnline = useOnline()
  const isPusherConnected = usePusherConnected()

  watch(isOnline, (current, previous) => current && !previous && onRefresh())
  watch(isPusherConnected, (current, previous) => current && !previous && onRefresh())
}
